import { mapGetters } from 'vuex'
import {
  CUSTOM_FILTERS_REQ,
  SAVE_CUSTOM_FILTERS,
  UPDATE_CUSTOM_FILTERS,
  DELETE_CUSTOM_FILTERS
} from '@/store/modules/custom-filters/custom-filters.type'

export default {
  data() {
    return {
      filterList: [],
      customFilters: {},
      activeFiltersData: [],
      filterErrMsg: '',
      disableSearchBox: false
    }
  },
  computed: {
    ...mapGetters(['customFilter'])
  },
  created() {
    this.loadCustomFilters()
  },
  methods: {
    addSearchTags(searchTagsList) {
      if (searchTagsList.length) {
        const newFilter = {
          filterName: '',
          filterQueries: _.cloneDeep(searchTagsList),
          userId: this.userProfile.id,
          tblId: this.tblId
        }
        this.$store.dispatch(SAVE_CUSTOM_FILTERS, newFilter).then(resp => {
          this.activeFiltersData.length = 0
          this.filterList.push({
            id: resp.data.id,
            name: '',
            filterTags: resp.data.filter_queries,
            editFlag: true,
            active: false,
            errFlag: false
          })
          this.focusFilterNameInput()
          this.disableSearchBox = true
        })
      }
    },
    removeBtnFromList(btn, index) {
      // removing content from search tag for deleted filter (only if filter was active)
      if (btn.active) {
        this.removeActiveFilterData(btn)
      }
      this.filterList.splice(index, 1)
      this.$store.dispatch(DELETE_CUSTOM_FILTERS, btn.id)
    },
    changeState(btn) {
      btn.active = !btn.active

      // if filter is activated, add corresponding data to 'activeFiltersData'
      if (btn.active) {
        this.activeFiltersData.push(...btn.filterTags.map(text => ({ text })))
      } else {
        // remove corresponding data of deactived filter from 'activeFiltersData'
        this.removeActiveFilterData(btn)
      }
    },
    removeActiveFilterData(btn) {
      let activeFiltersMappedData = this.activeFiltersData.map(tag => tag.text)
      btn.filterTags.forEach(tag => {
        let index = activeFiltersMappedData.indexOf(tag)
        if (index !== -1) {
          activeFiltersMappedData.splice(index, 1)
        }
      })
      this.activeFiltersData = activeFiltersMappedData.map(text => ({ text }))
    },
    focusFilterNameInput() {
      this.$nextTick(_ => {
        this.$refs.customFilterInput[0].focus()
      })
    },
    editFilter(btn) {
      btn.editFlag = true
      this.focusFilterNameInput()
    },
    deactivateFilter(action, tagName, delIdx) {
      this.filterList.forEach(el => {
        el.active = false
      })

      if (action === 'delete') {
        this.activeFiltersData.splice(delIdx, 1)
      } else if (action === 'add') {
        this.activeFiltersData.push({ text: tagName })
      }
    },
    handleFilterNameChange(btn) {
      btn.name = btn.name.trim()

      if (btn.name) {
        const filterNames = this.filterList
          .filter(filter => filter.id !== btn.id)
          .map(filter => filter.name.toLowerCase())

        if (filterNames.includes(btn.name.toLowerCase())) {
          this.filterErrMsg = 'Already exists'
          btn.errFlag = true
        } else {
          btn.errFlag = false
          btn.editFlag = false
          this.$store.dispatch(UPDATE_CUSTOM_FILTERS, btn)
          if (!this.activeFiltersData.length) {
            this.activeFiltersData = []
          }
          this.disableSearchBox = false
        }
      } else {
        this.filterErrMsg = 'Enter valid name'
        btn.errFlag = true
      }
    },
    loadCustomFilters() {
      this.$store.dispatch(CUSTOM_FILTERS_REQ, { uid: this.userProfile.id, tid: this.tblId }).then(data => {
        let temp = this.customFilter.map(fltr => {
          return {
            id: fltr.id,
            name: fltr.filter_name,
            filterTags: fltr.filter_queries,
            editFlag: false,
            active: false,
            errFlag: false
          }
        })
        this.filterList = _.cloneDeep(temp)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/customFilterMixin.js